<template>
    <BreadCrumb PageTitle="Ajouter un recensement" />
    <AddRecensement />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddRecensement from "@/components/Recensements/AddRecensement.vue";

export default defineComponent({
    name: "AddRecensementPage",
    components: {
        BreadCrumb,
        AddRecensement,
    },
});
</script>
